import React from "react"
import { graphql } from 'gatsby'


import Layout from "../components/layout"
import SEO from "../components/seo"
import HeroSection from "../components/Reuseable/HeroSection"
import InfoBlock from "../components/Reuseable/infoblock"



const AboutPage = ({data}) => (
  <Layout>
    <SEO title="Home" />
    
    <HeroSection
    img={data.img.childImageSharp.fluid}
      title = " About SVAYUKTYA_THEORAGNICS"
      subtitle =  ""
      heroclass = "about-background"
      />
    
    <InfoBlock  heading="About Vision"/>
    
    
  </Layout>
)

export const query = graphql`
{
 img: file(relativePath: { eq: "about.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }

`

export default AboutPage
